import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.array.sort.js";
import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { ComposedTreeDelegate } from './abstractTree.js';
import { ObjectTree, CompressibleObjectTree } from './objectTree.js';
import { TreeError, WeakMapper } from './tree.js';
import { dispose as _dispose, DisposableStore } from '../../../common/lifecycle.js';
import { Emitter, Event } from '../../../common/event.js';
import { timeout, createCancelablePromise } from '../../../common/async.js';
import { Iterable } from '../../../common/iterator.js';
import { ElementsDragAndDropData } from '../list/listView.js';
import { isPromiseCanceledError, onUnexpectedError } from '../../../common/errors.js';
import { removeClasses, addClasses } from '../../dom.js';
import { isFilterResult, getVisibleState } from './indexTreeModel.js';
import { treeItemLoadingIcon } from './treeIcons.js';

function createAsyncDataTreeNode(props) {
  return Object.assign(Object.assign({}, props), {
    children: [],
    refreshPromise: undefined,
    stale: true,
    slow: false,
    collapsedByDefault: undefined
  });
}

function isAncestor(ancestor, descendant) {
  if (!descendant.parent) {
    return false;
  } else if (descendant.parent === ancestor) {
    return true;
  } else {
    return isAncestor(ancestor, descendant.parent);
  }
}

function intersects(node, other) {
  return node === other || isAncestor(node, other) || isAncestor(other, node);
}

var AsyncDataTreeNodeWrapper = /*#__PURE__*/function () {
  function AsyncDataTreeNodeWrapper(node) {
    _classCallCheck(this, AsyncDataTreeNodeWrapper);

    this.node = node;
  }

  _createClass(AsyncDataTreeNodeWrapper, [{
    key: "element",
    get: function get() {
      return this.node.element.element;
    }
  }, {
    key: "children",
    get: function get() {
      return this.node.children.map(function (node) {
        return new AsyncDataTreeNodeWrapper(node);
      });
    }
  }, {
    key: "depth",
    get: function get() {
      return this.node.depth;
    }
  }, {
    key: "visibleChildrenCount",
    get: function get() {
      return this.node.visibleChildrenCount;
    }
  }, {
    key: "visibleChildIndex",
    get: function get() {
      return this.node.visibleChildIndex;
    }
  }, {
    key: "collapsible",
    get: function get() {
      return this.node.collapsible;
    }
  }, {
    key: "collapsed",
    get: function get() {
      return this.node.collapsed;
    }
  }, {
    key: "visible",
    get: function get() {
      return this.node.visible;
    }
  }, {
    key: "filterData",
    get: function get() {
      return this.node.filterData;
    }
  }]);

  return AsyncDataTreeNodeWrapper;
}();

var AsyncDataTreeRenderer = /*#__PURE__*/function () {
  function AsyncDataTreeRenderer(renderer, nodeMapper, onDidChangeTwistieState) {
    _classCallCheck(this, AsyncDataTreeRenderer);

    this.renderer = renderer;
    this.nodeMapper = nodeMapper;
    this.onDidChangeTwistieState = onDidChangeTwistieState;
    this.renderedNodes = new Map();
    this.templateId = renderer.templateId;
  }

  _createClass(AsyncDataTreeRenderer, [{
    key: "renderTemplate",
    value: function renderTemplate(container) {
      var templateData = this.renderer.renderTemplate(container);
      return {
        templateData: templateData
      };
    }
  }, {
    key: "renderElement",
    value: function renderElement(node, index, templateData, height) {
      this.renderer.renderElement(this.nodeMapper.map(node), index, templateData.templateData, height);
    }
  }, {
    key: "renderTwistie",
    value: function renderTwistie(element, twistieElement) {
      if (element.slow) {
        addClasses(twistieElement, treeItemLoadingIcon.classNames);
      } else {
        removeClasses(twistieElement, treeItemLoadingIcon.classNames);
      }

      return false;
    }
  }, {
    key: "disposeElement",
    value: function disposeElement(node, index, templateData, height) {
      if (this.renderer.disposeElement) {
        this.renderer.disposeElement(this.nodeMapper.map(node), index, templateData.templateData, height);
      }
    }
  }, {
    key: "disposeTemplate",
    value: function disposeTemplate(templateData) {
      this.renderer.disposeTemplate(templateData.templateData);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.renderedNodes.clear();
    }
  }]);

  return AsyncDataTreeRenderer;
}();

function asTreeEvent(e) {
  return {
    browserEvent: e.browserEvent,
    elements: e.elements.map(function (e) {
      return e.element;
    })
  };
}

function asTreeMouseEvent(e) {
  return {
    browserEvent: e.browserEvent,
    element: e.element && e.element.element,
    target: e.target
  };
}

var AsyncDataTreeElementsDragAndDropData = /*#__PURE__*/function (_ElementsDragAndDropD) {
  _inherits(AsyncDataTreeElementsDragAndDropData, _ElementsDragAndDropD);

  var _super = _createSuper(AsyncDataTreeElementsDragAndDropData);

  function AsyncDataTreeElementsDragAndDropData(data) {
    var _this;

    _classCallCheck(this, AsyncDataTreeElementsDragAndDropData);

    _this = _super.call(this, data.elements.map(function (node) {
      return node.element;
    }));
    _this.data = data;
    return _this;
  }

  return AsyncDataTreeElementsDragAndDropData;
}(ElementsDragAndDropData);

function asAsyncDataTreeDragAndDropData(data) {
  if (data instanceof ElementsDragAndDropData) {
    return new AsyncDataTreeElementsDragAndDropData(data);
  }

  return data;
}

var AsyncDataTreeNodeListDragAndDrop = /*#__PURE__*/function () {
  function AsyncDataTreeNodeListDragAndDrop(dnd) {
    _classCallCheck(this, AsyncDataTreeNodeListDragAndDrop);

    this.dnd = dnd;
  }

  _createClass(AsyncDataTreeNodeListDragAndDrop, [{
    key: "getDragURI",
    value: function getDragURI(node) {
      return this.dnd.getDragURI(node.element);
    }
  }, {
    key: "getDragLabel",
    value: function getDragLabel(nodes, originalEvent) {
      if (this.dnd.getDragLabel) {
        return this.dnd.getDragLabel(nodes.map(function (node) {
          return node.element;
        }), originalEvent);
      }

      return undefined;
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(data, originalEvent) {
      if (this.dnd.onDragStart) {
        this.dnd.onDragStart(asAsyncDataTreeDragAndDropData(data), originalEvent);
      }
    }
  }, {
    key: "onDragOver",
    value: function onDragOver(data, targetNode, targetIndex, originalEvent) {
      var raw = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      return this.dnd.onDragOver(asAsyncDataTreeDragAndDropData(data), targetNode && targetNode.element, targetIndex, originalEvent);
    }
  }, {
    key: "drop",
    value: function drop(data, targetNode, targetIndex, originalEvent) {
      this.dnd.drop(asAsyncDataTreeDragAndDropData(data), targetNode && targetNode.element, targetIndex, originalEvent);
    }
  }, {
    key: "onDragEnd",
    value: function onDragEnd(originalEvent) {
      if (this.dnd.onDragEnd) {
        this.dnd.onDragEnd(originalEvent);
      }
    }
  }]);

  return AsyncDataTreeNodeListDragAndDrop;
}();

function asObjectTreeOptions(options) {
  return options && Object.assign(Object.assign({}, options), {
    collapseByDefault: true,
    identityProvider: options.identityProvider && {
      getId: function getId(el) {
        return options.identityProvider.getId(el.element);
      }
    },
    dnd: options.dnd && new AsyncDataTreeNodeListDragAndDrop(options.dnd),
    multipleSelectionController: options.multipleSelectionController && {
      isSelectionSingleChangeEvent: function isSelectionSingleChangeEvent(e) {
        return options.multipleSelectionController.isSelectionSingleChangeEvent(Object.assign(Object.assign({}, e), {
          element: e.element
        }));
      },
      isSelectionRangeChangeEvent: function isSelectionRangeChangeEvent(e) {
        return options.multipleSelectionController.isSelectionRangeChangeEvent(Object.assign(Object.assign({}, e), {
          element: e.element
        }));
      }
    },
    accessibilityProvider: options.accessibilityProvider && Object.assign(Object.assign({}, options.accessibilityProvider), {
      getPosInSet: undefined,
      getSetSize: undefined,
      getRole: options.accessibilityProvider.getRole ? function (el) {
        return options.accessibilityProvider.getRole(el.element);
      } : function () {
        return 'treeitem';
      },
      isChecked: options.accessibilityProvider.isChecked ? function (e) {
        var _a;

        return !!((_a = options.accessibilityProvider) === null || _a === void 0 ? void 0 : _a.isChecked(e.element));
      } : undefined,
      getAriaLabel: function getAriaLabel(e) {
        return options.accessibilityProvider.getAriaLabel(e.element);
      },
      getWidgetAriaLabel: function getWidgetAriaLabel() {
        return options.accessibilityProvider.getWidgetAriaLabel();
      },
      getWidgetRole: options.accessibilityProvider.getWidgetRole ? function () {
        return options.accessibilityProvider.getWidgetRole();
      } : function () {
        return 'tree';
      },
      getAriaLevel: options.accessibilityProvider.getAriaLevel && function (node) {
        return options.accessibilityProvider.getAriaLevel(node.element);
      },
      getActiveDescendantId: options.accessibilityProvider.getActiveDescendantId && function (node) {
        return options.accessibilityProvider.getActiveDescendantId(node.element);
      }
    }),
    filter: options.filter && {
      filter: function filter(e, parentVisibility) {
        return options.filter.filter(e.element, parentVisibility);
      }
    },
    keyboardNavigationLabelProvider: options.keyboardNavigationLabelProvider && Object.assign(Object.assign({}, options.keyboardNavigationLabelProvider), {
      getKeyboardNavigationLabel: function getKeyboardNavigationLabel(e) {
        return options.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(e.element);
      }
    }),
    sorter: undefined,
    expandOnlyOnTwistieClick: typeof options.expandOnlyOnTwistieClick === 'undefined' ? undefined : typeof options.expandOnlyOnTwistieClick !== 'function' ? options.expandOnlyOnTwistieClick : function (e) {
      return options.expandOnlyOnTwistieClick(e.element);
    },
    additionalScrollHeight: options.additionalScrollHeight
  });
}

function dfs(node, fn) {
  fn(node);
  node.children.forEach(function (child) {
    return dfs(child, fn);
  });
}

export var AsyncDataTree = /*#__PURE__*/function () {
  function AsyncDataTree(user, container, delegate, renderers, dataSource) {
    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

    _classCallCheck(this, AsyncDataTree);

    this.user = user;
    this.dataSource = dataSource;
    this.nodes = new Map();
    this.subTreeRefreshPromises = new Map();
    this.refreshPromises = new Map();
    this._onDidRender = new Emitter();
    this._onDidChangeNodeSlowState = new Emitter();
    this.nodeMapper = new WeakMapper(function (node) {
      return new AsyncDataTreeNodeWrapper(node);
    });
    this.disposables = new DisposableStore();
    this.identityProvider = options.identityProvider;
    this.autoExpandSingleChildren = typeof options.autoExpandSingleChildren === 'undefined' ? false : options.autoExpandSingleChildren;
    this.sorter = options.sorter;
    this.collapseByDefault = options.collapseByDefault;
    this.tree = this.createTree(user, container, delegate, renderers, options);
    this.root = createAsyncDataTreeNode({
      element: undefined,
      parent: null,
      hasChildren: true
    });

    if (this.identityProvider) {
      this.root = Object.assign(Object.assign({}, this.root), {
        id: null
      });
    }

    this.nodes.set(null, this.root);
    this.tree.onDidChangeCollapseState(this._onDidChangeCollapseState, this, this.disposables);
  }

  _createClass(AsyncDataTree, [{
    key: "onDidChangeFocus",
    get: function get() {
      return Event.map(this.tree.onDidChangeFocus, asTreeEvent);
    }
  }, {
    key: "onDidChangeSelection",
    get: function get() {
      return Event.map(this.tree.onDidChangeSelection, asTreeEvent);
    }
  }, {
    key: "onMouseDblClick",
    get: function get() {
      return Event.map(this.tree.onMouseDblClick, asTreeMouseEvent);
    }
  }, {
    key: "onPointer",
    get: function get() {
      return Event.map(this.tree.onPointer, asTreeMouseEvent);
    }
  }, {
    key: "onDidFocus",
    get: function get() {
      return this.tree.onDidFocus;
    }
  }, {
    key: "onDidDispose",
    get: function get() {
      return this.tree.onDidDispose;
    }
  }, {
    key: "createTree",
    value: function createTree(user, container, delegate, renderers, options) {
      var _this2 = this;

      var objectTreeDelegate = new ComposedTreeDelegate(delegate);
      var objectTreeRenderers = renderers.map(function (r) {
        return new AsyncDataTreeRenderer(r, _this2.nodeMapper, _this2._onDidChangeNodeSlowState.event);
      });
      var objectTreeOptions = asObjectTreeOptions(options) || {};
      return new ObjectTree(user, container, objectTreeDelegate, objectTreeRenderers, objectTreeOptions);
    }
  }, {
    key: "updateOptions",
    value: function updateOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.tree.updateOptions(options);
    } // Widget

  }, {
    key: "getHTMLElement",
    value: function getHTMLElement() {
      return this.tree.getHTMLElement();
    }
  }, {
    key: "scrollTop",
    get: function get() {
      return this.tree.scrollTop;
    },
    set: function set(scrollTop) {
      this.tree.scrollTop = scrollTop;
    }
  }, {
    key: "domFocus",
    value: function domFocus() {
      this.tree.domFocus();
    }
  }, {
    key: "layout",
    value: function layout(height, width) {
      this.tree.layout(height, width);
    }
  }, {
    key: "style",
    value: function style(styles) {
      this.tree.style(styles);
    } // Model

  }, {
    key: "getInput",
    value: function getInput() {
      return this.root.element;
    }
  }, {
    key: "setInput",
    value: function setInput(input, viewState) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var viewStateContext;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.refreshPromises.forEach(function (promise) {
                  return promise.cancel();
                });
                this.refreshPromises.clear();
                this.root.element = input;
                viewStateContext = viewState && {
                  viewState: viewState,
                  focus: [],
                  selection: []
                };
                _context.next = 6;
                return this._updateChildren(input, true, false, viewStateContext);

              case 6:
                if (viewStateContext) {
                  this.tree.setFocus(viewStateContext.focus);
                  this.tree.setSelection(viewStateContext.selection);
                }

                if (viewState && typeof viewState.scrollTop === 'number') {
                  this.scrollTop = viewState.scrollTop;
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "_updateChildren",
    value: function _updateChildren() {
      var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.root.element;
      var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var rerender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var viewStateContext = arguments.length > 3 ? arguments[3] : undefined;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var node;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(typeof this.root.element === 'undefined')) {
                  _context2.next = 2;
                  break;
                }

                throw new TreeError(this.user, 'Tree input not set');

              case 2:
                if (!this.root.refreshPromise) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 5;
                return this.root.refreshPromise;

              case 5:
                _context2.next = 7;
                return Event.toPromise(this._onDidRender.event);

              case 7:
                node = this.getDataNode(element);
                _context2.next = 10;
                return this.refreshAndRenderNode(node, recursive, viewStateContext);

              case 10:
                if (rerender) {
                  try {
                    this.tree.rerender(node);
                  } catch (_a) {// missing nodes are fine, this could've resulted from
                    // parallel refresh calls, removing `node` altogether
                  }
                }

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    } // View

  }, {
    key: "rerender",
    value: function rerender(element) {
      if (element === undefined || element === this.root.element) {
        this.tree.rerender();
        return;
      }

      var node = this.getDataNode(element);
      this.tree.rerender(node);
    }
  }, {
    key: "collapse",
    value: function collapse(element) {
      var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var node = this.getDataNode(element);
      return this.tree.collapse(node === this.root ? null : node, recursive);
    }
  }, {
    key: "expand",
    value: function expand(element) {
      var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var node, result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(typeof this.root.element === 'undefined')) {
                  _context3.next = 2;
                  break;
                }

                throw new TreeError(this.user, 'Tree input not set');

              case 2:
                if (!this.root.refreshPromise) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 5;
                return this.root.refreshPromise;

              case 5:
                _context3.next = 7;
                return Event.toPromise(this._onDidRender.event);

              case 7:
                node = this.getDataNode(element);

                if (!(this.tree.hasElement(node) && !this.tree.isCollapsible(node))) {
                  _context3.next = 10;
                  break;
                }

                return _context3.abrupt("return", false);

              case 10:
                if (!node.refreshPromise) {
                  _context3.next = 15;
                  break;
                }

                _context3.next = 13;
                return this.root.refreshPromise;

              case 13:
                _context3.next = 15;
                return Event.toPromise(this._onDidRender.event);

              case 15:
                if (!(node !== this.root && !node.refreshPromise && !this.tree.isCollapsed(node))) {
                  _context3.next = 17;
                  break;
                }

                return _context3.abrupt("return", false);

              case 17:
                result = this.tree.expand(node === this.root ? null : node, recursive);

                if (!node.refreshPromise) {
                  _context3.next = 23;
                  break;
                }

                _context3.next = 21;
                return this.root.refreshPromise;

              case 21:
                _context3.next = 23;
                return Event.toPromise(this._onDidRender.event);

              case 23:
                return _context3.abrupt("return", result);

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "setSelection",
    value: function setSelection(elements, browserEvent) {
      var _this3 = this;

      var nodes = elements.map(function (e) {
        return _this3.getDataNode(e);
      });
      this.tree.setSelection(nodes, browserEvent);
    }
  }, {
    key: "getSelection",
    value: function getSelection() {
      var nodes = this.tree.getSelection();
      return nodes.map(function (n) {
        return n.element;
      });
    }
  }, {
    key: "setFocus",
    value: function setFocus(elements, browserEvent) {
      var _this4 = this;

      var nodes = elements.map(function (e) {
        return _this4.getDataNode(e);
      });
      this.tree.setFocus(nodes, browserEvent);
    }
  }, {
    key: "getFocus",
    value: function getFocus() {
      var nodes = this.tree.getFocus();
      return nodes.map(function (n) {
        return n.element;
      });
    }
  }, {
    key: "reveal",
    value: function reveal(element, relativeTop) {
      this.tree.reveal(this.getDataNode(element), relativeTop);
    } // Implementation

  }, {
    key: "getDataNode",
    value: function getDataNode(element) {
      var node = this.nodes.get(element === this.root.element ? null : element);

      if (!node) {
        throw new TreeError(this.user, "Data tree node not found: ".concat(element));
      }

      return node;
    }
  }, {
    key: "refreshAndRenderNode",
    value: function refreshAndRenderNode(node, recursive, viewStateContext) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.refreshNode(node, recursive, viewStateContext);

              case 2:
                this.render(node, viewStateContext);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "refreshNode",
    value: function refreshNode(node, recursive, viewStateContext) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this5 = this;

        var result;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.subTreeRefreshPromises.forEach(function (refreshPromise, refreshNode) {
                  if (!result && intersects(refreshNode, node)) {
                    result = refreshPromise.then(function () {
                      return _this5.refreshNode(node, recursive, viewStateContext);
                    });
                  }
                });

                if (!result) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt("return", result);

              case 3:
                return _context5.abrupt("return", this.doRefreshSubTree(node, recursive, viewStateContext));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "doRefreshSubTree",
    value: function doRefreshSubTree(node, recursive, viewStateContext) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this6 = this;

        var done, childrenToRefresh;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                node.refreshPromise = new Promise(function (c) {
                  return done = c;
                });
                this.subTreeRefreshPromises.set(node, node.refreshPromise);
                node.refreshPromise.finally(function () {
                  node.refreshPromise = undefined;

                  _this6.subTreeRefreshPromises.delete(node);
                });
                _context6.prev = 3;
                _context6.next = 6;
                return this.doRefreshNode(node, recursive, viewStateContext);

              case 6:
                childrenToRefresh = _context6.sent;
                node.stale = false;
                _context6.next = 10;
                return Promise.all(childrenToRefresh.map(function (child) {
                  return _this6.doRefreshSubTree(child, recursive, viewStateContext);
                }));

              case 10:
                _context6.prev = 10;
                done();
                return _context6.finish(10);

              case 13:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[3,, 10, 13]]);
      }));
    }
  }, {
    key: "doRefreshNode",
    value: function doRefreshNode(node, recursive, viewStateContext) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _this7 = this;

        var childrenPromise, slowTimeout, children;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                node.hasChildren = !!this.dataSource.hasChildren(node.element);

                if (!node.hasChildren) {
                  childrenPromise = Promise.resolve(Iterable.empty());
                } else {
                  slowTimeout = timeout(800);
                  slowTimeout.then(function () {
                    node.slow = true;

                    _this7._onDidChangeNodeSlowState.fire(node);
                  }, function (_) {
                    return null;
                  });
                  childrenPromise = this.doGetChildren(node).finally(function () {
                    return slowTimeout.cancel();
                  });
                }

                _context7.prev = 2;
                _context7.next = 5;
                return childrenPromise;

              case 5:
                children = _context7.sent;
                return _context7.abrupt("return", this.setChildren(node, children, recursive, viewStateContext));

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7["catch"](2);

                if (node !== this.root) {
                  this.tree.collapse(node === this.root ? null : node);
                }

                if (!isPromiseCanceledError(_context7.t0)) {
                  _context7.next = 14;
                  break;
                }

                return _context7.abrupt("return", []);

              case 14:
                throw _context7.t0;

              case 15:
                _context7.prev = 15;

                if (node.slow) {
                  node.slow = false;

                  this._onDidChangeNodeSlowState.fire(node);
                }

                return _context7.finish(15);

              case 18:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[2, 9, 15, 18]]);
      }));
    }
  }, {
    key: "doGetChildren",
    value: function doGetChildren(node) {
      var _this8 = this;

      var result = this.refreshPromises.get(node);

      if (result) {
        return result;
      }

      result = createCancelablePromise(function () {
        return __awaiter(_this8, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
          var children;
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.next = 2;
                  return this.dataSource.getChildren(node.element);

                case 2:
                  children = _context8.sent;
                  return _context8.abrupt("return", this.processChildren(children));

                case 4:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, this);
        }));
      });
      this.refreshPromises.set(node, result);
      return result.finally(function () {
        _this8.refreshPromises.delete(node);
      });
    }
  }, {
    key: "_onDidChangeCollapseState",
    value: function _onDidChangeCollapseState(_ref) {
      var node = _ref.node,
          deep = _ref.deep;

      if (node.element === null) {
        return;
      }

      if (!node.collapsed && node.element.stale) {
        if (deep) {
          this.collapse(node.element.element);
        } else {
          this.refreshAndRenderNode(node.element, false).catch(onUnexpectedError);
        }
      }
    }
  }, {
    key: "setChildren",
    value: function setChildren(node, childrenElementsIterable, recursive, viewStateContext) {
      var _this9 = this,
          _node$children;

      var childrenElements = _toConsumableArray(childrenElementsIterable); // perf: if the node was and still is a leaf, avoid all this hassle


      if (node.children.length === 0 && childrenElements.length === 0) {
        return [];
      }

      var nodesToForget = new Map();
      var childrenTreeNodesById = new Map();

      var _iterator = _createForOfIteratorHelper(node.children),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var child = _step.value;
          nodesToForget.set(child.element, child);

          if (this.identityProvider) {
            var collapsed = this.tree.isCollapsed(child);
            childrenTreeNodesById.set(child.id, {
              node: child,
              collapsed: collapsed
            });
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var childrenToRefresh = [];
      var children = childrenElements.map(function (element) {
        var hasChildren = !!_this9.dataSource.hasChildren(element);

        if (!_this9.identityProvider) {
          var asyncDataTreeNode = createAsyncDataTreeNode({
            element: element,
            parent: node,
            hasChildren: hasChildren
          });

          if (hasChildren && _this9.collapseByDefault && !_this9.collapseByDefault(element)) {
            asyncDataTreeNode.collapsedByDefault = false;
            childrenToRefresh.push(asyncDataTreeNode);
          }

          return asyncDataTreeNode;
        }

        var id = _this9.identityProvider.getId(element).toString();

        var result = childrenTreeNodesById.get(id);

        if (result) {
          var _asyncDataTreeNode = result.node;
          nodesToForget.delete(_asyncDataTreeNode.element);

          _this9.nodes.delete(_asyncDataTreeNode.element);

          _this9.nodes.set(element, _asyncDataTreeNode);

          _asyncDataTreeNode.element = element;
          _asyncDataTreeNode.hasChildren = hasChildren;

          if (recursive) {
            if (result.collapsed) {
              _asyncDataTreeNode.children.forEach(function (node) {
                return dfs(node, function (node) {
                  return _this9.nodes.delete(node.element);
                });
              });

              _asyncDataTreeNode.children.splice(0, _asyncDataTreeNode.children.length);

              _asyncDataTreeNode.stale = true;
            } else {
              childrenToRefresh.push(_asyncDataTreeNode);
            }
          } else if (hasChildren && _this9.collapseByDefault && !_this9.collapseByDefault(element)) {
            _asyncDataTreeNode.collapsedByDefault = false;
            childrenToRefresh.push(_asyncDataTreeNode);
          }

          return _asyncDataTreeNode;
        }

        var childAsyncDataTreeNode = createAsyncDataTreeNode({
          element: element,
          parent: node,
          id: id,
          hasChildren: hasChildren
        });

        if (viewStateContext && viewStateContext.viewState.focus && viewStateContext.viewState.focus.indexOf(id) > -1) {
          viewStateContext.focus.push(childAsyncDataTreeNode);
        }

        if (viewStateContext && viewStateContext.viewState.selection && viewStateContext.viewState.selection.indexOf(id) > -1) {
          viewStateContext.selection.push(childAsyncDataTreeNode);
        }

        if (viewStateContext && viewStateContext.viewState.expanded && viewStateContext.viewState.expanded.indexOf(id) > -1) {
          childrenToRefresh.push(childAsyncDataTreeNode);
        } else if (hasChildren && _this9.collapseByDefault && !_this9.collapseByDefault(element)) {
          childAsyncDataTreeNode.collapsedByDefault = false;
          childrenToRefresh.push(childAsyncDataTreeNode);
        }

        return childAsyncDataTreeNode;
      });

      var _iterator2 = _createForOfIteratorHelper(nodesToForget.values()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _node = _step2.value;
          dfs(_node, function (node) {
            return _this9.nodes.delete(node.element);
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var _iterator3 = _createForOfIteratorHelper(children),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _child = _step3.value;
          this.nodes.set(_child.element, _child);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      (_node$children = node.children).splice.apply(_node$children, [0, node.children.length].concat(_toConsumableArray(children))); // TODO@joao this doesn't take filter into account


      if (node !== this.root && this.autoExpandSingleChildren && children.length === 1 && childrenToRefresh.length === 0) {
        children[0].collapsedByDefault = false;
        childrenToRefresh.push(children[0]);
      }

      return childrenToRefresh;
    }
  }, {
    key: "render",
    value: function render(node, viewStateContext) {
      var _this10 = this;

      var children = node.children.map(function (node) {
        return _this10.asTreeElement(node, viewStateContext);
      });
      this.tree.setChildren(node === this.root ? null : node, children);

      if (node !== this.root) {
        this.tree.setCollapsible(node, node.hasChildren);
      }

      this._onDidRender.fire();
    }
  }, {
    key: "asTreeElement",
    value: function asTreeElement(node, viewStateContext) {
      var _this11 = this;

      if (node.stale) {
        return {
          element: node,
          collapsible: node.hasChildren,
          collapsed: true
        };
      }

      var collapsed;

      if (viewStateContext && viewStateContext.viewState.expanded && node.id && viewStateContext.viewState.expanded.indexOf(node.id) > -1) {
        collapsed = false;
      } else {
        collapsed = node.collapsedByDefault;
      }

      node.collapsedByDefault = undefined;
      return {
        element: node,
        children: node.hasChildren ? Iterable.map(node.children, function (child) {
          return _this11.asTreeElement(child, viewStateContext);
        }) : [],
        collapsible: node.hasChildren,
        collapsed: collapsed
      };
    }
  }, {
    key: "processChildren",
    value: function processChildren(children) {
      if (this.sorter) {
        children = _toConsumableArray(children).sort(this.sorter.compare.bind(this.sorter));
      }

      return children;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.disposables.dispose();
    }
  }]);

  return AsyncDataTree;
}();

var CompressibleAsyncDataTreeNodeWrapper = /*#__PURE__*/function () {
  function CompressibleAsyncDataTreeNodeWrapper(node) {
    _classCallCheck(this, CompressibleAsyncDataTreeNodeWrapper);

    this.node = node;
  }

  _createClass(CompressibleAsyncDataTreeNodeWrapper, [{
    key: "element",
    get: function get() {
      return {
        elements: this.node.element.elements.map(function (e) {
          return e.element;
        }),
        incompressible: this.node.element.incompressible
      };
    }
  }, {
    key: "children",
    get: function get() {
      return this.node.children.map(function (node) {
        return new CompressibleAsyncDataTreeNodeWrapper(node);
      });
    }
  }, {
    key: "depth",
    get: function get() {
      return this.node.depth;
    }
  }, {
    key: "visibleChildrenCount",
    get: function get() {
      return this.node.visibleChildrenCount;
    }
  }, {
    key: "visibleChildIndex",
    get: function get() {
      return this.node.visibleChildIndex;
    }
  }, {
    key: "collapsible",
    get: function get() {
      return this.node.collapsible;
    }
  }, {
    key: "collapsed",
    get: function get() {
      return this.node.collapsed;
    }
  }, {
    key: "visible",
    get: function get() {
      return this.node.visible;
    }
  }, {
    key: "filterData",
    get: function get() {
      return this.node.filterData;
    }
  }]);

  return CompressibleAsyncDataTreeNodeWrapper;
}();

var CompressibleAsyncDataTreeRenderer = /*#__PURE__*/function () {
  function CompressibleAsyncDataTreeRenderer(renderer, nodeMapper, compressibleNodeMapperProvider, onDidChangeTwistieState) {
    _classCallCheck(this, CompressibleAsyncDataTreeRenderer);

    this.renderer = renderer;
    this.nodeMapper = nodeMapper;
    this.compressibleNodeMapperProvider = compressibleNodeMapperProvider;
    this.onDidChangeTwistieState = onDidChangeTwistieState;
    this.renderedNodes = new Map();
    this.disposables = [];
    this.templateId = renderer.templateId;
  }

  _createClass(CompressibleAsyncDataTreeRenderer, [{
    key: "renderTemplate",
    value: function renderTemplate(container) {
      var templateData = this.renderer.renderTemplate(container);
      return {
        templateData: templateData
      };
    }
  }, {
    key: "renderElement",
    value: function renderElement(node, index, templateData, height) {
      this.renderer.renderElement(this.nodeMapper.map(node), index, templateData.templateData, height);
    }
  }, {
    key: "renderCompressedElements",
    value: function renderCompressedElements(node, index, templateData, height) {
      this.renderer.renderCompressedElements(this.compressibleNodeMapperProvider().map(node), index, templateData.templateData, height);
    }
  }, {
    key: "renderTwistie",
    value: function renderTwistie(element, twistieElement) {
      if (element.slow) {
        addClasses(twistieElement, treeItemLoadingIcon.classNames);
      } else {
        removeClasses(twistieElement, treeItemLoadingIcon.classNames);
      }

      return false;
    }
  }, {
    key: "disposeElement",
    value: function disposeElement(node, index, templateData, height) {
      if (this.renderer.disposeElement) {
        this.renderer.disposeElement(this.nodeMapper.map(node), index, templateData.templateData, height);
      }
    }
  }, {
    key: "disposeCompressedElements",
    value: function disposeCompressedElements(node, index, templateData, height) {
      if (this.renderer.disposeCompressedElements) {
        this.renderer.disposeCompressedElements(this.compressibleNodeMapperProvider().map(node), index, templateData.templateData, height);
      }
    }
  }, {
    key: "disposeTemplate",
    value: function disposeTemplate(templateData) {
      this.renderer.disposeTemplate(templateData.templateData);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.renderedNodes.clear();
      this.disposables = _dispose(this.disposables);
    }
  }]);

  return CompressibleAsyncDataTreeRenderer;
}();

function asCompressibleObjectTreeOptions(options) {
  var objectTreeOptions = options && asObjectTreeOptions(options);
  return objectTreeOptions && Object.assign(Object.assign({}, objectTreeOptions), {
    keyboardNavigationLabelProvider: objectTreeOptions.keyboardNavigationLabelProvider && Object.assign(Object.assign({}, objectTreeOptions.keyboardNavigationLabelProvider), {
      getCompressedNodeKeyboardNavigationLabel: function getCompressedNodeKeyboardNavigationLabel(els) {
        return options.keyboardNavigationLabelProvider.getCompressedNodeKeyboardNavigationLabel(els.map(function (e) {
          return e.element;
        }));
      }
    })
  });
}

export var CompressibleAsyncDataTree = /*#__PURE__*/function (_AsyncDataTree) {
  _inherits(CompressibleAsyncDataTree, _AsyncDataTree);

  var _super2 = _createSuper(CompressibleAsyncDataTree);

  function CompressibleAsyncDataTree(user, container, virtualDelegate, compressionDelegate, renderers, dataSource) {
    var _this12;

    var options = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

    _classCallCheck(this, CompressibleAsyncDataTree);

    _this12 = _super2.call(this, user, container, virtualDelegate, renderers, dataSource, options);
    _this12.compressionDelegate = compressionDelegate;
    _this12.compressibleNodeMapper = new WeakMapper(function (node) {
      return new CompressibleAsyncDataTreeNodeWrapper(node);
    });
    _this12.filter = options.filter;
    return _this12;
  }

  _createClass(CompressibleAsyncDataTree, [{
    key: "createTree",
    value: function createTree(user, container, delegate, renderers, options) {
      var _this13 = this;

      var objectTreeDelegate = new ComposedTreeDelegate(delegate);
      var objectTreeRenderers = renderers.map(function (r) {
        return new CompressibleAsyncDataTreeRenderer(r, _this13.nodeMapper, function () {
          return _this13.compressibleNodeMapper;
        }, _this13._onDidChangeNodeSlowState.event);
      });
      var objectTreeOptions = asCompressibleObjectTreeOptions(options) || {};
      return new CompressibleObjectTree(user, container, objectTreeDelegate, objectTreeRenderers, objectTreeOptions);
    }
  }, {
    key: "asTreeElement",
    value: function asTreeElement(node, viewStateContext) {
      return Object.assign({
        incompressible: this.compressionDelegate.isIncompressible(node.element)
      }, _get(_getPrototypeOf(CompressibleAsyncDataTree.prototype), "asTreeElement", this).call(this, node, viewStateContext));
    }
  }, {
    key: "updateOptions",
    value: function updateOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.tree.updateOptions(options);
    }
  }, {
    key: "render",
    value: function render(node, viewStateContext) {
      var _this14 = this;

      if (!this.identityProvider) {
        return _get(_getPrototypeOf(CompressibleAsyncDataTree.prototype), "render", this).call(this, node, viewStateContext);
      } // Preserve traits across compressions. Hacky but does the trick.
      // This is hard to fix properly since it requires rewriting the traits
      // across trees and lists. Let's just keep it this way for now.


      var getId = function getId(element) {
        return _this14.identityProvider.getId(element).toString();
      };

      var getUncompressedIds = function getUncompressedIds(nodes) {
        var result = new Set();

        var _iterator4 = _createForOfIteratorHelper(nodes),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _node2 = _step4.value;

            var compressedNode = _this14.tree.getCompressedTreeNode(_node2 === _this14.root ? null : _node2);

            if (!compressedNode.element) {
              continue;
            }

            var _iterator5 = _createForOfIteratorHelper(compressedNode.element.elements),
                _step5;

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var _node3 = _step5.value;
                result.add(getId(_node3.element));
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        return result;
      };

      var oldSelection = getUncompressedIds(this.tree.getSelection());
      var oldFocus = getUncompressedIds(this.tree.getFocus());

      _get(_getPrototypeOf(CompressibleAsyncDataTree.prototype), "render", this).call(this, node, viewStateContext);

      var selection = this.getSelection();
      var didChangeSelection = false;
      var focus = this.getFocus();
      var didChangeFocus = false;

      var visit = function visit(node) {
        var compressedNode = node.element;

        if (compressedNode) {
          for (var i = 0; i < compressedNode.elements.length; i++) {
            var id = getId(compressedNode.elements[i].element);
            var element = compressedNode.elements[compressedNode.elements.length - 1].element; // github.com/microsoft/vscode/issues/85938

            if (oldSelection.has(id) && selection.indexOf(element) === -1) {
              selection.push(element);
              didChangeSelection = true;
            }

            if (oldFocus.has(id) && focus.indexOf(element) === -1) {
              focus.push(element);
              didChangeFocus = true;
            }
          }
        }

        node.children.forEach(visit);
      };

      visit(this.tree.getCompressedTreeNode(node === this.root ? null : node));

      if (didChangeSelection) {
        this.setSelection(selection);
      }

      if (didChangeFocus) {
        this.setFocus(focus);
      }
    } // For compressed async data trees, `TreeVisibility.Recurse` doesn't currently work
    // and we have to filter everything beforehand
    // Related to #85193 and #85835

  }, {
    key: "processChildren",
    value: function processChildren(children) {
      var _this15 = this;

      if (this.filter) {
        children = Iterable.filter(children, function (e) {
          var result = _this15.filter.filter(e, 1
          /* Visible */
          );

          var visibility = getVisibility(result);

          if (visibility === 2
          /* Recurse */
          ) {
            throw new Error('Recursive tree visibility not supported in async data compressed trees');
          }

          return visibility === 1
          /* Visible */
          ;
        });
      }

      return _get(_getPrototypeOf(CompressibleAsyncDataTree.prototype), "processChildren", this).call(this, children);
    }
  }]);

  return CompressibleAsyncDataTree;
}(AsyncDataTree);

function getVisibility(filterResult) {
  if (typeof filterResult === 'boolean') {
    return filterResult ? 1
    /* Visible */
    : 0
    /* Hidden */
    ;
  } else if (isFilterResult(filterResult)) {
    return getVisibleState(filterResult.visibility);
  } else {
    return getVisibleState(filterResult);
  }
}